import authenticate from './authenticate';
import fetchToken from './fetch-token';
import setSiteId from './set-site-id';

export default {
  authenticate,
  fetchToken,
  setSiteId,
};
